










































import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import { formatSmallMoney } from '@/helpers/jsUtils';
import Vue, { PropType } from 'vue';
import { getEmailStatusConfig } from '../../../helpers/stats-utils';
import { CAMPAIGN_TYPE } from '@/store/shared';

export default Vue.extend({
  name: 'CustomerEmailCard',
  mixins: [CopyToClipboard],
  props: {
    email: {
      type: Object as PropType<any>,
    },
  },
  data() {
    return {
      formatSmallMoney,
    };
  },
  computed: {
    emailStatus() {
      return getEmailStatusConfig(this.email);
    },
    emailLabel() {
      const campaignType = this.email.campaign?.campaignType;
      if (campaignType === CAMPAIGN_TYPE.DELINQUENCY) {
        return 'Dunning Email';
      }
      if (campaignType === CAMPAIGN_TYPE.REACTIVATION) {
        return 'Reactivation Email';
      }
      return 'Email';
    },
  },
});
